module.exports = __webpack_public_path__ + "img/aws-summit-logo.5207f5ef.png";